// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sites Page - Estilo inspirado en Figma */
.sites-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #0a0a0a;
  color: #ffffff;
  overflow: hidden;
}

/* Header */
.sites-page-header {
  background: #1a1a1a;
  border-bottom: 1px solid #374151;
  padding: 24px;
}

.sites-page-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.sites-page-title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
}

.sites-page-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #9ca3af;
}

/* Search and Filters Row */
.sites-search-and-filters {
  display: flex;
  gap: 12px;
  align-items: center;
}

.sites-search-container {
  position: relative;
  flex: 1 1;
}

.sites-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
}

.sites-search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.sites-search-input:focus {
  border-color: #A61B34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.sites-search-input::placeholder {
  color: #6b7280;
}

/* Filters */
.sites-filter-select {
  min-width: 160px;
  padding: 10px 12px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
}

.sites-filter-select:focus {
  border-color: #A61B34;
}

/* Buttons */
.sites-btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #A61B34;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.sites-btn-primary:hover:not(:disabled) {
  background: #8B1528;
}

.sites-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sites-btn-secondary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #374151;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.sites-btn-secondary:hover:not(:disabled) {
  background: #4b5563;
}

.sites-btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Dashboard Cards */
.sites-dashboard {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin: 16px 0;
  width: 100%;
  min-width: 0;
}

.sites-stat-card {
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-width: 0;
  overflow: hidden;
}

/* Tarjeta Desconectadas: filtro (zona principal) + botón actualizar aparte */
.sites-stat-card-split {
  padding: 0;
  cursor: default;
}

.sites-stat-card-main {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  min-width: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  color: inherit;
  font: inherit;
}

.sites-stat-refresh-only {
  flex-shrink: 0;
  width: 48px;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
  border: none;
  border-left: 1px solid #374151;
  cursor: pointer;
  color: inherit;
  border-radius: 0 7px 7px 0;
  transition: background 0.15s;
}

.sites-stat-refresh-only:hover:not(:disabled) {
  background: rgba(166, 27, 52, 0.12);
}

.sites-stat-refresh-only:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.sites-stat-card:hover {
  border-color: #4b5563;
}

.sites-stat-left {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.sites-stat-label {
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sites-stat-number {
  font-size: clamp(1.35rem, 4vw, 1.875rem);
  font-weight: 700;
  color: #ffffff;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.sites-stat-green {
  color: #22c55e;
}

.sites-stat-red {
  color: #ef4444;
}

.sites-stat-icon {
  color: #4b5563;
  flex-shrink: 0;
}

.sites-stat-icon-red {
  color: #A61B34;
}

/* Card con borde rojo permanente (Total Cámaras) */
.sites-stat-default-red {
  border-color: #A61B34;
}

/* Card inactiva (borde gris) */
.sites-stat-default {
  border-color: #374151;
}

/* Card activa con glow rojo */
.sites-stat-active-red {
  border-color: #A61B34;
  box-shadow: 0 4px 14px rgba(166, 27, 52, 0.25);
}

/* Card activa con glow verde */
.sites-stat-active-green {
  border-color: #22c55e;
  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.25);
}

.sites-stat-active-green .sites-stat-icon {
  color: #22c55e;
}

.sites-stat-orange {
  color: #F59E0B;
}

.sites-stat-icon-orange {
  color: #F59E0B;
}

.sites-stat-active-orange {
  border-color: #F59E0B;
  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.25);
}

.sites-stat-active-orange .sites-stat-icon {
  color: #F59E0B;
}

/* Content Area */
.sites-content {
  flex: 1 1;
  overflow: auto;
  padding: 24px;
}

/* Error Message */
.sites-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #f87171;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 0 24px 16px 24px;
  font-size: 14px;
}

/* Form Card */
.sites-form-card {
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 12px;
  padding: 20px;
  margin: 0 24px 24px 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.sites-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sites-form-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
}

.sites-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sites-form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (max-width: 900px) {
  .sites-form-grid {
    grid-template-columns: 1fr;
  }
}

.sites-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sites-field span {
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
}

.sites-input,
.sites-select {
  padding: 10px 12px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.sites-input:focus,
.sites-select:focus {
  border-color: #A61B34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.sites-input::placeholder {
  color: #6b7280;
}

.sites-form-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.sites-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e5e7eb;
  font-size: 14px;
  cursor: pointer;
}

.sites-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #A61B34;
}

/* Table Container */
.sites-table-container {
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.sites-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #0a0a0a;
  border-bottom: 1px solid #374151;
}

.sites-table-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

/* Table */
.sites-table {
  width: 100%;
  border-collapse: collapse;
}

.sites-table thead {
  background: #0a0a0a;
}

.sites-table th {
  padding: 16px 24px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #374151;
}

.sites-table tbody {
  background: #1a1a1a;
}

.sites-table tbody tr {
  border-bottom: 1px solid #374151;
  transition: background-color 0.2s;
}

.sites-table tbody tr:hover {
  background: #252525;
}

.sites-table td {
  padding: 16px 24px;
  font-size: 14px;
  color: #ffffff;
}

.sites-empty {
  text-align: center;
  padding: 48px 24px !important;
}

.sites-empty-icon {
  color: #6b7280;
  margin: 0 auto 16px auto;
}

.sites-empty p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
}

/* Table Cells */
.sites-cell-with-icon {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sites-icon-badge {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(166, 27, 52, 0.2);
  border: 1px solid rgba(166, 27, 52, 0.3);
  border-radius: 8px;
  color: #A61B34;
}

.sites-cell-title {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.sites-cell-subtitle {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}

.sites-cell-muted {
  color: #fbbf24;
  font-size: 11px;
}

.sites-cell-text {
  font-size: 14px;
  color: #e5e7eb;
}

.sites-cell-mono {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #e5e7eb;
}

.sites-ellipsis {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Badges */
.sites-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

.sites-badge-success {
  background: rgba(34, 197, 94, 0.15);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.sites-badge-inactive {
  background: rgba(107, 114, 128, 0.15);
  color: #9ca3af;
  border: 1px solid rgba(107, 114, 128, 0.3);
}

.sites-badge-info {
  background: rgba(59, 130, 246, 0.15);
  color: #93c5fd;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.sites-badge-warning {
  background: rgba(251, 146, 60, 0.15);
  color: #fdba74;
  border: 1px solid rgba(251, 146, 60, 0.3);
}

/* Estado del sitio (sites_states): semáforo + etiqueta */
.sites-state-sema {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  line-height: 1.2;
}

.sites-state-sema__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.12);
}

.sites-state-sema--on {
  color: #bbf7d0;
  background: rgba(34, 197, 94, 0.14);
  border-color: rgba(34, 197, 94, 0.35);
}
.sites-state-sema--on .sites-state-sema__dot {
  background: #22c55e;
}

.sites-state-sema--issue {
  color: #ffedd5;
  background: rgba(249, 115, 22, 0.16);
  border-color: rgba(249, 115, 22, 0.4);
}
.sites-state-sema--issue .sites-state-sema__dot {
  background: #f97316;
}

.sites-state-sema--maint {
  color: #fef9c3;
  background: rgba(234, 179, 8, 0.14);
  border-color: rgba(234, 179, 8, 0.4);
}
.sites-state-sema--maint .sites-state-sema__dot {
  background: #eab308;
}

.sites-state-sema--off {
  color: #fecaca;
  background: rgba(220, 38, 38, 0.14);
  border-color: rgba(220, 38, 38, 0.38);
}
.sites-state-sema--off .sites-state-sema__dot {
  background: #dc2626;
}

.sites-state-sema--unknown {
  color: #d1d5db;
  background: rgba(107, 114, 128, 0.18);
  border-color: rgba(107, 114, 128, 0.35);
}
.sites-state-sema--unknown .sites-state-sema__dot {
  background: #6b7280;
}

.sites-badge-primary {
  background: rgba(224, 112, 84, 0.15);
  color: #FDC4A8;
  border: 1px solid rgba(224, 112, 84, 0.35);
}

/* Action Buttons: mismo tono neutro que Usuarios (users-icon-btn) */
.sites-actions {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}

.sites-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #3f3f46;
  background: #252525;
  color: #d4d4d8;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.sites-action-btn:hover:not(:disabled) {
  background: #2f2f2f;
  border-color: rgba(166, 27, 52, 0.28);
}

.sites-action-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.sites-action-btn--danger:hover:not(:disabled) {
  border-color: rgba(239, 68, 68, 0.45);
  color: #f87171;
}

/* Subsection */
.sites-subsection {
  margin-top: 24px;
}

.sites-subsection-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 24px;
}

.sites-subsection-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
}

.sites-header-actions {
  display: flex;
  gap: 12px;
}

/* Paginación */
.sites-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #0a0a0a;
  border-top: 1px solid #374151;
}

.sites-pagination-info {
  font-size: 13px;
  color: #9ca3af;
}

.sites-pagination-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.sites-pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #374151;
  border-radius: 6px;
  background: transparent;
  color: #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.sites-pagination-btn:hover:not(:disabled):not(.active) {
  background: #374151;
  border-color: #4b5563;
}

.sites-pagination-btn.active {
  background: #A61B34;
  border-color: #A61B34;
  color: #ffffff;
  font-weight: 600;
}

.sites-pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.sites-pagination-dots {
  padding: 0 4px;
  color: #6b7280;
  font-size: 13px;
}

/* Devices Summary Column */
.sites-devices-none {
  font-size: 12px;
  color: #6b7280;
}

.sites-devices-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.2s;
}

.sites-devices-summary:hover {
  opacity: 0.8;
}

.sites-device-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.sites-device-chip-camera,
.sites-device-chip-xtam,
.sites-device-chip-miniot,
.sites-device-chip-router,
.sites-device-chip-button,
.sites-device-chip-siren {
  background: rgba(156, 163, 175, 0.15);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.3);
}

/* Devices Modal */
.sites-devices-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.sites-devices-modal {
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.sites-devices-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #374151;
}

.sites-devices-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sites-devices-modal-subtitle {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.sites-devices-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #374151;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.sites-devices-modal-close:hover {
  background: #4b5563;
  color: #ffffff;
}

.sites-devices-modal-content {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1 1;
}

.sites-devices-modal-section {
  margin-bottom: 20px;
}

.sites-devices-modal-section:last-child {
  margin-bottom: 0;
}

.sites-devices-modal-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #e5e7eb;
}

.sites-devices-modal-section-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.sites-devices-modal-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sites-devices-modal-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
}

.sites-devices-modal-item-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.sites-devices-modal-item-name {
  font-size: 14px;
  font-weight: 500;
  color: #f3f4f6;
  font-family: 'Courier New', monospace;
}

.sites-devices-modal-item-detail {
  font-size: 12px;
  color: #9ca3af;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sites-devices-modal-item-ip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-family: 'Courier New', monospace;
  color: #86efac;
  background: rgba(34, 197, 94, 0.1);
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid rgba(34, 197, 94, 0.2);
  white-space: nowrap;
  margin-left: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sites-devices-modal-item-ip:hover {
  background: rgba(34, 197, 94, 0.2);
  border-color: rgba(34, 197, 94, 0.4);
  transform: scale(1.02);
}

.sites-devices-modal-item-ip:active {
  transform: scale(0.98);
}

.sites-devices-modal-item-ip.copied {
  background: rgba(34, 197, 94, 0.25);
  border-color: rgba(34, 197, 94, 0.5);
  color: #4ade80;
}

.sites-devices-modal-item-ip svg {
  opacity: 0.6;
  flex-shrink: 0;
}

.sites-devices-modal-item-ip:hover svg {
  opacity: 1;
}

.sites-devices-modal-item-ip.copied svg {
  opacity: 1;
  color: #4ade80;
}

/* Toast de IP copiada */
.sites-ip-copied-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(34, 197, 94, 0.15);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, 0.3);
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 10000;
  animation: slideUpFadeIn 0.3s ease;
}

@keyframes slideUpFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.sites-devices-modal-empty {
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
}

.sites-devices-modal-empty p {
  margin: 12px 0 0 0;
  font-size: 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .sites-page-header {
    padding: 16px;
  }

  .sites-page-header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .sites-search-and-filters {
    flex-direction: column;
    width: 100%;
  }

  .sites-search-container {
    width: 100%;
  }

  .sites-filter-select {
    width: 100%;
  }

  .sites-content {
    padding: 16px;
  }

  .sites-form-card {
    margin: 0 16px 16px 16px;
  }

  .sites-table th,
  .sites-table td {
    padding: 12px 16px;
  }

  .sites-actions {
    flex-direction: column;
  }

  .sites-dashboard {
    grid-template-columns: 1fr;
  }

  .sites-pagination {
    flex-direction: column;
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SitesPage.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;EAME,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;EACzC,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":["/* Sites Page - Estilo inspirado en Figma */\n.sites-page {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #0a0a0a;\n  color: #ffffff;\n  overflow: hidden;\n}\n\n/* Header */\n.sites-page-header {\n  background: #1a1a1a;\n  border-bottom: 1px solid #374151;\n  padding: 24px;\n}\n\n.sites-page-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.sites-page-title {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.sites-page-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n/* Search and Filters Row */\n.sites-search-and-filters {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.sites-search-container {\n  position: relative;\n  flex: 1;\n}\n\n.sites-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  pointer-events: none;\n}\n\n.sites-search-input {\n  width: 100%;\n  padding: 12px 12px 12px 44px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.sites-search-input:focus {\n  border-color: #A61B34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.sites-search-input::placeholder {\n  color: #6b7280;\n}\n\n/* Filters */\n.sites-filter-select {\n  min-width: 160px;\n  padding: 10px 12px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.sites-filter-select:focus {\n  border-color: #A61B34;\n}\n\n/* Buttons */\n.sites-btn-primary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #A61B34;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.sites-btn-primary:hover:not(:disabled) {\n  background: #8B1528;\n}\n\n.sites-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.sites-btn-secondary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #374151;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.sites-btn-secondary:hover:not(:disabled) {\n  background: #4b5563;\n}\n\n.sites-btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Dashboard Cards */\n.sites-dashboard {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin: 16px 0;\n  width: 100%;\n  min-width: 0;\n}\n\n.sites-stat-card {\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Tarjeta Desconectadas: filtro (zona principal) + botón actualizar aparte */\n.sites-stat-card-split {\n  padding: 0;\n  cursor: default;\n}\n\n.sites-stat-card-main {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  min-width: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  color: inherit;\n  font: inherit;\n}\n\n.sites-stat-refresh-only {\n  flex-shrink: 0;\n  width: 48px;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.2);\n  border: none;\n  border-left: 1px solid #374151;\n  cursor: pointer;\n  color: inherit;\n  border-radius: 0 7px 7px 0;\n  transition: background 0.15s;\n}\n\n.sites-stat-refresh-only:hover:not(:disabled) {\n  background: rgba(166, 27, 52, 0.12);\n}\n\n.sites-stat-refresh-only:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.sites-stat-card:hover {\n  border-color: #4b5563;\n}\n\n.sites-stat-left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.sites-stat-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ca3af;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sites-stat-number {\n  font-size: clamp(1.35rem, 4vw, 1.875rem);\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.1;\n  font-variant-numeric: tabular-nums;\n}\n\n.sites-stat-green {\n  color: #22c55e;\n}\n\n.sites-stat-red {\n  color: #ef4444;\n}\n\n.sites-stat-icon {\n  color: #4b5563;\n  flex-shrink: 0;\n}\n\n.sites-stat-icon-red {\n  color: #A61B34;\n}\n\n/* Card con borde rojo permanente (Total Cámaras) */\n.sites-stat-default-red {\n  border-color: #A61B34;\n}\n\n/* Card inactiva (borde gris) */\n.sites-stat-default {\n  border-color: #374151;\n}\n\n/* Card activa con glow rojo */\n.sites-stat-active-red {\n  border-color: #A61B34;\n  box-shadow: 0 4px 14px rgba(166, 27, 52, 0.25);\n}\n\n/* Card activa con glow verde */\n.sites-stat-active-green {\n  border-color: #22c55e;\n  box-shadow: 0 4px 14px rgba(34, 197, 94, 0.25);\n}\n\n.sites-stat-active-green .sites-stat-icon {\n  color: #22c55e;\n}\n\n.sites-stat-orange {\n  color: #F59E0B;\n}\n\n.sites-stat-icon-orange {\n  color: #F59E0B;\n}\n\n.sites-stat-active-orange {\n  border-color: #F59E0B;\n  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.25);\n}\n\n.sites-stat-active-orange .sites-stat-icon {\n  color: #F59E0B;\n}\n\n/* Content Area */\n.sites-content {\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n}\n\n/* Error Message */\n.sites-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #f87171;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin: 0 24px 16px 24px;\n  font-size: 14px;\n}\n\n/* Form Card */\n.sites-form-card {\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  padding: 20px;\n  margin: 0 24px 24px 24px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.sites-form-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.sites-form-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.sites-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sites-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 900px) {\n  .sites-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.sites-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sites-field span {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n.sites-input,\n.sites-select {\n  padding: 10px 12px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.sites-input:focus,\n.sites-select:focus {\n  border-color: #A61B34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.sites-input::placeholder {\n  color: #6b7280;\n}\n\n.sites-form-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.sites-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #e5e7eb;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.sites-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #A61B34;\n}\n\n/* Table Container */\n.sites-table-container {\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.sites-table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #0a0a0a;\n  border-bottom: 1px solid #374151;\n}\n\n.sites-table-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* Table */\n.sites-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.sites-table thead {\n  background: #0a0a0a;\n}\n\n.sites-table th {\n  padding: 16px 24px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid #374151;\n}\n\n.sites-table tbody {\n  background: #1a1a1a;\n}\n\n.sites-table tbody tr {\n  border-bottom: 1px solid #374151;\n  transition: background-color 0.2s;\n}\n\n.sites-table tbody tr:hover {\n  background: #252525;\n}\n\n.sites-table td {\n  padding: 16px 24px;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n.sites-empty {\n  text-align: center;\n  padding: 48px 24px !important;\n}\n\n.sites-empty-icon {\n  color: #6b7280;\n  margin: 0 auto 16px auto;\n}\n\n.sites-empty p {\n  margin: 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Table Cells */\n.sites-cell-with-icon {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sites-icon-badge {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(166, 27, 52, 0.2);\n  border: 1px solid rgba(166, 27, 52, 0.3);\n  border-radius: 8px;\n  color: #A61B34;\n}\n\n.sites-cell-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.sites-cell-subtitle {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-top: 2px;\n}\n\n.sites-cell-muted {\n  color: #fbbf24;\n  font-size: 11px;\n}\n\n.sites-cell-text {\n  font-size: 14px;\n  color: #e5e7eb;\n}\n\n.sites-cell-mono {\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  color: #e5e7eb;\n}\n\n.sites-ellipsis {\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Badges */\n.sites-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.sites-badge-success {\n  background: rgba(34, 197, 94, 0.15);\n  color: #86efac;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.sites-badge-inactive {\n  background: rgba(107, 114, 128, 0.15);\n  color: #9ca3af;\n  border: 1px solid rgba(107, 114, 128, 0.3);\n}\n\n.sites-badge-info {\n  background: rgba(59, 130, 246, 0.15);\n  color: #93c5fd;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.sites-badge-warning {\n  background: rgba(251, 146, 60, 0.15);\n  color: #fdba74;\n  border: 1px solid rgba(251, 146, 60, 0.3);\n}\n\n/* Estado del sitio (sites_states): semáforo + etiqueta */\n.sites-state-sema {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 12px 5px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid transparent;\n  line-height: 1.2;\n}\n\n.sites-state-sema__dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.12);\n}\n\n.sites-state-sema--on {\n  color: #bbf7d0;\n  background: rgba(34, 197, 94, 0.14);\n  border-color: rgba(34, 197, 94, 0.35);\n}\n.sites-state-sema--on .sites-state-sema__dot {\n  background: #22c55e;\n}\n\n.sites-state-sema--issue {\n  color: #ffedd5;\n  background: rgba(249, 115, 22, 0.16);\n  border-color: rgba(249, 115, 22, 0.4);\n}\n.sites-state-sema--issue .sites-state-sema__dot {\n  background: #f97316;\n}\n\n.sites-state-sema--maint {\n  color: #fef9c3;\n  background: rgba(234, 179, 8, 0.14);\n  border-color: rgba(234, 179, 8, 0.4);\n}\n.sites-state-sema--maint .sites-state-sema__dot {\n  background: #eab308;\n}\n\n.sites-state-sema--off {\n  color: #fecaca;\n  background: rgba(220, 38, 38, 0.14);\n  border-color: rgba(220, 38, 38, 0.38);\n}\n.sites-state-sema--off .sites-state-sema__dot {\n  background: #dc2626;\n}\n\n.sites-state-sema--unknown {\n  color: #d1d5db;\n  background: rgba(107, 114, 128, 0.18);\n  border-color: rgba(107, 114, 128, 0.35);\n}\n.sites-state-sema--unknown .sites-state-sema__dot {\n  background: #6b7280;\n}\n\n.sites-badge-primary {\n  background: rgba(224, 112, 84, 0.15);\n  color: #FDC4A8;\n  border: 1px solid rgba(224, 112, 84, 0.35);\n}\n\n/* Action Buttons: mismo tono neutro que Usuarios (users-icon-btn) */\n.sites-actions {\n  display: flex;\n  gap: 6px;\n  justify-content: flex-end;\n}\n\n.sites-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid #3f3f46;\n  background: #252525;\n  color: #d4d4d8;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.sites-action-btn:hover:not(:disabled) {\n  background: #2f2f2f;\n  border-color: rgba(166, 27, 52, 0.28);\n}\n\n.sites-action-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.sites-action-btn--danger:hover:not(:disabled) {\n  border-color: rgba(239, 68, 68, 0.45);\n  color: #f87171;\n}\n\n/* Subsection */\n.sites-subsection {\n  margin-top: 24px;\n}\n\n.sites-subsection-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding: 0 24px;\n}\n\n.sites-subsection-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.sites-header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Paginación */\n.sites-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: #0a0a0a;\n  border-top: 1px solid #374151;\n}\n\n.sites-pagination-info {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.sites-pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.sites-pagination-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  background: transparent;\n  color: #e5e7eb;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.sites-pagination-btn:hover:not(:disabled):not(.active) {\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.sites-pagination-btn.active {\n  background: #A61B34;\n  border-color: #A61B34;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.sites-pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.sites-pagination-dots {\n  padding: 0 4px;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n/* Devices Summary Column */\n.sites-devices-none {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.sites-devices-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.sites-devices-summary:hover {\n  opacity: 0.8;\n}\n\n.sites-device-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.sites-device-chip-camera,\n.sites-device-chip-xtam,\n.sites-device-chip-miniot,\n.sites-device-chip-router,\n.sites-device-chip-button,\n.sites-device-chip-siren {\n  background: rgba(156, 163, 175, 0.15);\n  color: #d1d5db;\n  border: 1px solid rgba(156, 163, 175, 0.3);\n}\n\n/* Devices Modal */\n.sites-devices-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  backdrop-filter: blur(4px);\n}\n\n.sites-devices-modal {\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.sites-devices-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #374151;\n}\n\n.sites-devices-modal-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sites-devices-modal-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.sites-devices-modal-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: #374151;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.sites-devices-modal-close:hover {\n  background: #4b5563;\n  color: #ffffff;\n}\n\n.sites-devices-modal-content {\n  padding: 20px 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.sites-devices-modal-section {\n  margin-bottom: 20px;\n}\n\n.sites-devices-modal-section:last-child {\n  margin-bottom: 0;\n}\n\n.sites-devices-modal-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  color: #e5e7eb;\n}\n\n.sites-devices-modal-section-header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.sites-devices-modal-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sites-devices-modal-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n}\n\n.sites-devices-modal-item-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.sites-devices-modal-item-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #f3f4f6;\n  font-family: 'Courier New', monospace;\n}\n\n.sites-devices-modal-item-detail {\n  font-size: 12px;\n  color: #9ca3af;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sites-devices-modal-item-ip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-family: 'Courier New', monospace;\n  color: #86efac;\n  background: rgba(34, 197, 94, 0.1);\n  padding: 4px 10px;\n  border-radius: 4px;\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  white-space: nowrap;\n  margin-left: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sites-devices-modal-item-ip:hover {\n  background: rgba(34, 197, 94, 0.2);\n  border-color: rgba(34, 197, 94, 0.4);\n  transform: scale(1.02);\n}\n\n.sites-devices-modal-item-ip:active {\n  transform: scale(0.98);\n}\n\n.sites-devices-modal-item-ip.copied {\n  background: rgba(34, 197, 94, 0.25);\n  border-color: rgba(34, 197, 94, 0.5);\n  color: #4ade80;\n}\n\n.sites-devices-modal-item-ip svg {\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n.sites-devices-modal-item-ip:hover svg {\n  opacity: 1;\n}\n\n.sites-devices-modal-item-ip.copied svg {\n  opacity: 1;\n  color: #4ade80;\n}\n\n/* Toast de IP copiada */\n.sites-ip-copied-toast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(34, 197, 94, 0.15);\n  color: #86efac;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  backdrop-filter: blur(12px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  z-index: 10000;\n  animation: slideUpFadeIn 0.3s ease;\n}\n\n@keyframes slideUpFadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.sites-devices-modal-empty {\n  text-align: center;\n  padding: 40px 20px;\n  color: #6b7280;\n}\n\n.sites-devices-modal-empty p {\n  margin: 12px 0 0 0;\n  font-size: 14px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .sites-page-header {\n    padding: 16px;\n  }\n\n  .sites-page-header-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .sites-search-and-filters {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .sites-search-container {\n    width: 100%;\n  }\n\n  .sites-filter-select {\n    width: 100%;\n  }\n\n  .sites-content {\n    padding: 16px;\n  }\n\n  .sites-form-card {\n    margin: 0 16px 16px 16px;\n  }\n\n  .sites-table th,\n  .sites-table td {\n    padding: 12px 16px;\n  }\n\n  .sites-actions {\n    flex-direction: column;\n  }\n\n  .sites-dashboard {\n    grid-template-columns: 1fr;\n  }\n\n  .sites-pagination {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
